import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../@core/service/api.service';

@Component({
  selector: 'ngx-dump-viewer',
  templateUrl: './dump-viewer.component.html',
  styleUrls: ['./dump-viewer.component.scss']
})
export class DumpViewerComponent implements OnInit {
  folders: string[] = [];
  files: string[] = [];
  selectedFolder: string = '';
  selectedFile: string = '';
  param: string = '';
  value: string = '';
  result: any;

  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this.loadFolders();
  }

  async loadFolders(): Promise<void> {
    this.folders = [
      ' ',
      ...await this.api.getFolders('/data/backup/mongo/dumps'),
      ...await this.api.getFolders('/data/backup/mongo/dumps-fsless'),
    ].reverse();
  }

  async onFolderSelect(folder: string): Promise<void> {
    this.selectedFolder = folder;
    this.files = await this.api.getFiles(folder);
  }

  onFileSelect(file: string): void {
    this.selectedFile = file;
  }

  async onSearch(): Promise<void> {
    const searchParams = {
      folder: this.selectedFolder,
      file: this.selectedFile,
      param: this.param,
      value: this.value
    };
    const res = await this.api.searchInFile(searchParams);
    console.log('onSearch', searchParams, res);
    this.result = JSON.stringify(res, null, 2);
  }
}
